const pdfVersion = async (token, id) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/view_docVersion/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default pdfVersion;
